module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Work on this book started at the end of August 2020, just a few days after the 80th anniversary of Trotsky’s death in Mexico City, on 21 August 1940, following a dramatic and ultimately successful assassination attempt the previous day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would like to thank Jacqui Petrie, Ken and Di Barrell, Chrissie Parfitt, Ian Rycroft, Paul Wilmott, Tony Lywood – and two of my ex-History students, Nicky Barrell and Patrick Fitzgerald – for kindly reading, and offering constructive criticism on early drafts of various chapters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks are also due to Chris Evan Brown for shaping my proposal, and to Claire Hopkins, Laura Hirst and the rest of the team at Pen & Sword for pre-publication improvements. Thanks are also due to Thomas Bohm, of Design, Illustration & Typesetting, for his skill – and patience! – in drawing up the Family Tree and the various maps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Any remaining faults and errors are down to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would also like to thank our daughters, Megan and Vanessa, and our grandchildren, Alexander and Emilia, for their support and encouragement – especially over the past eleven years, and during what was a difficult year for so many.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("And finally, I owe a huge debt of gratitude to Cyn who, for Christmas 1972, bought me Wyndham and King’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotsky: A Documentary")]), _vm._v(" – which, 50 years later, helped me shape and complete this book.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Allan Todd")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("June 2021")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Keswick")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bbbc5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 72
// module chunks = 0